export enum WhiteBlackLists {
	Whitelist = 'WHITELIST',
	Blacklist = 'BLACKLIST',
}

export type WhiteBlackList = WhiteBlackLists.Whitelist | WhiteBlackLists.Blacklist;
